<template>
    <div
        v-if="!isEditing"
        class="relative"
    >
        <span
            v-if="shouldTruncate"
            :title="modelValue"
            class="cursor-help"
        >
            {{ truncatedValue }}
        </span>
        <span v-else>
            {{ modelValue || NO_DATA_SYMBOL }}
        </span>
    </div>
    <BaseFieldInput
        v-if="isEditing"
        ref="inputRef"
        :model-value="modelValue"
        :vuelidate-field="vuelidateField"
        :error-messages="errorMessages"
        :is-clearable="true"
        :name="name"
        :data-spec-class="dataSpecClass"
        class="py-0.5"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.enter="emits('update')"
        @keyup.esc="emits('cancel')"
        @clear="emits('clear')"
    />
</template>

<script setup lang="ts">
import { defineProps, defineEmits, withDefaults, ref, computed } from 'vue';
import { NO_DATA_SYMBOL } from '@/modules/your/composables/core';
import { truncate } from '@/utils/stringUtils';

const emits = defineEmits(['update:modelValue', 'update', 'cancel', 'clear']);
defineExpose({ focus, select });

interface Props {
    isEditing: boolean;
    modelValue: string;
    name: string;
    vuelidateField: unknown;
    errorMessages?: string[];
    dataSpecClass?: string;
    maxLength?: number;
}

const props = withDefaults(defineProps<Props>(), {
    errorMessages: undefined,
    dataSpecClass: 'field-edit',
    maxLength: 15,
});

const inputRef = ref(null);

const shouldTruncate = computed(() => {
    return props.modelValue && props.modelValue.length > props.maxLength;
});

const truncatedValue = computed(() => {
    if (!props.modelValue) return '';
    return shouldTruncate.value ? truncate(props.modelValue, props.maxLength) : props.modelValue;
});

function focus() {
    inputRef.value.focus();
}

function select() {
    inputRef.value.select();
}
</script>
